import type { ReactNode } from 'react'

import classnames from 'classnames'

import styles from './LozengeList.module.css'

export interface LozengeListProps {
  children: ReactNode | ReactNode[]
  className?: string
  testID?: string
  stack?: boolean
  gap?: 'small'
}

export default function LozengeList({
  className,
  testID,
  children,
  stack,
  gap,
}: LozengeListProps) {
  return (
    <div className={styles.base} data-testid={testID}>
      <div className={classnames(styles.listScroll, className)}>
        <div
          className={classnames(
            styles.list,
            stack && styles.stackList,
            gap === 'small' && styles.smallGap
          )}
        >
          {children}
        </div>
      </div>
    </div>
  )
}
